export default __webpack_public_path__ + "static/media/Gold_step_invest_logo.a6161100.png";